<template>
  <div class="d-roll-box-style" v-bind:style="{ textAlign: digitRollTextAlign, transform: 'rotate(' + rotate + 'deg)', opacity: opacity }">
    <ul :class="!isFixed ? 'd-roll-list number_flex' : 'd-roll-list d-roll-list-left'">
      <template v-if="options.showIcon && getIconPosition === 'left' && !onWarningStatus">
        <cxIcon class="icon" v-if="iconType === 'icon'" :options="options" :iconStyle="getIconStyle"></cxIcon>
        <img class="icon" v-else-if="iconType === 'img' && iconSrc" :src="iconSrc" :style="getIconImgStyle" />
      </template>
      <template v-if="options.showIcon && getIconPosition === 'left' && onWarningStatus">
        <cxIcon class="icon" v-if="warningIconType === 'icon'" :options="options" :iconStyle="getIconStyle" iconSrcName="warningIconSrc"></cxIcon>
        <img class="icon" v-else-if="warningIconType === 'img' && warningIconSrc" :src="warningIconSrc" :style="getIconImgStyle" />
      </template>
      <span v-if="getShowPrefix" :style="getPrefixStyle">{{ prefix }}</span>
      <template v-for="(item, i) of digitsArray">
        <li
          v-if="digitsArray[i] !== '.' && digitsArray[i] !== ','"
          class="d-roll-item"
          :style="getLiStyle"
          ref="dRollLi"
        >
          <div :style="getDivStyle">{{ item }}</div>
        </li>
        <div v-else :style="getOtherSymbolStyle">
          {{ item }}
        </div>
      </template>
      <span v-if="getShowSuffix" :style="getSuffixStyle">{{ suffix }}</span>
      <template v-if="options.showIcon && getIconPosition === 'right' && !onWarningStatus">
        <cxIcon class="icon" v-if="iconType === 'icon'" :options="options" :iconStyle="getIconStyle"></cxIcon>
        <img class="icon" v-else-if="iconType === 'img' && iconSrc" :src="iconSrc" :style="getIconImgStyle" />
      </template>
      <template v-if="options.showIcon && getIconPosition === 'right' && onWarningStatus">
        <cxIcon class="icon" v-if="warningIconType === 'icon'" :options="options" :iconStyle="getIconStyle" iconSrcName="warningIconSrc"></cxIcon>
        <img class="icon" v-else-if="warningIconType === 'img' && warningIconSrc" :src="warningIconSrc" :style="getIconImgStyle" />
      </template>
    </ul>
  </div>
</template>
<script>
import { requestAnimationFrame, cancelAnimationFrame } from "utils/requestAnimationFrame.js"
export default {
  name: "DigitSwitchCore",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    },
    startVal: {
      type: Number,
      required: false,
      default: 0
    },
    endVal: {
      type: Number,
      required: false,
      default: 2017
    },
    duration: {
      type: Number,
      required: false,
      default: 3000
    },
    autoplay: {
      type: Boolean,
      required: false,
      default: true
    },
    isFixed: {
      type: Boolean,
      required: false,
      default: false
    },
    decimals: {
      type: Number,
      required: false,
      default: 0,
      validator(value) {
        return value >= 0
      }
    },
    decimal: {
      type: String,
      required: false,
      default: "."
    },
    separator: {
      type: String,
      required: false,
      default: ","
    },
    prefix: {
      type: String,
      required: false,
      default: ""
    },
    getShowPrefix: {
      type: Boolean,
      default: false
    },
    getPrefixStyle: {
      type: Object,
      default: null
    },
    getShowSuffix: {
      type: Boolean,
      default: false
    },
    getSuffixStyle: {
      type: Object,
      default: null
    },
    suffix: {
      type: String,
      required: false,
      default: ""
    },
    getLiStyle: {
      type: Object,
      default: null
    },
    getDivStyle: {
      type: Object,
      default: null
    },
    getOtherSymbolStyle: {
      type: Object,
      default: null
    },
    getHeight: {
      type: Number,
      required: false,
      default: 0
    },
    useEasing: {
      type: Boolean,
      required: false,
      default: true
    },
    easingFn: {
      type: Function,
      default(t, b, c, d) {
        return (c * (-Math.pow(2, (-10 * t) / d) + 1) * 1024) / 1023 + b
      }
    },
    digitRollTextAlign: {
      type: String,
      required: false
    },
    rotate: {
      type: Number,
      required: false
    },
    opacity: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      localStartVal: this.startVal,
      displayValue: this.formatNumber(this.startVal),
      digitsArray: [],
      printVal: null,
      paused: false,
      localDuration: this.duration,
      startTime: null,
      timestamp: null,
      remaining: null,
      rAF: null,
      isWarning: false
    }
  },
  computed: {
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    countDown() {
      return this.startVal > this.endVal
    },
    getIconPosition() {
      return this.options ? this.options.iconPosition : "left"
    },
    iconType() {
      return this.options ? this.options.iconType : "img"
    },
    iconSrc() {
      return this.options ? this.options.iconSrc : ""
    },
    getMargin() {
      let iconMarginBottom = this.options.iconMarginBottom
      if(this.options.iconMarginBottom === undefined){
        iconMarginBottom = 0
      }
      let marginStr = ""
      if(this.isFixed){
        marginStr = this.options.iconPosition === "left"
            ? `${iconMarginBottom}px ${this.options.iconMargin}px 0 0`
            : `${iconMarginBottom}px 0 0 ${this.options.iconMargin}px`
      }else{
        marginStr = this.options.iconPosition === "left"
            ? `0 ${this.options.iconMargin}px ${iconMarginBottom}px 0`
            : `0 0 ${iconMarginBottom}px ${this.options.iconMargin}px`
      }
      return marginStr
    },
    getIconStyle() {
      // let color1 = this.options.iconColorIsThemeColor
      //     ? this.themeColor
      //     : this.options.iconColor && this.options.iconColor.color
      //         ? this.options.iconColor.color
      //         : this.options.iconColor
      let color1 = this.$parseColor(this.options.iconColor, {
        isThemeColor: this.options.iconColorIsThemeColor
      })
      if(this.isWarning){
        // color1 = this.options.warningIconColorIsThemeColor
        //     ? this.themeColor
        //     : this.options.warningIconColor && this.options.warningIconColor.color
        //         ? this.options.warningIconColor.color
        //         : this.options.warningIconColor
        color1 = this.$parseColor(this.options.warningIconColor, {
          isThemeColor: this.options.warningIconColorIsThemeColor
        })
      }
      return {
        display: "inline-block",
        "--color": color1,
        fontSize: this.options.iconSize + "px",
        width: this.options.iconSize + "px",
        height: this.options.iconSize + "px",
        margin: this.getMargin
      }
    },
    getIconImgStyle() {
      return {
        width: this.options.iconSize + "px",
        margin: this.getMargin
      }
    },
    // 是否开启了预警状态 且 有条件数据
    onWarningStatus(){
      if (this.options.onWarning && this.options.dynamicData && this.options.dynamicData.length > 0) {
        return true
      }else{
        return false
      }
    },
    warningIconSrc: {
      get() {
        let warningIconSrc = this.options.iconSrc
        if(this.isWarning){
          warningIconSrc = this.options.warningIconSrc
        }
        return warningIconSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "warningIconSrc", false)
      }
    },
    warningIconColor: {
      get() {
        return this.options.warningIconColor || this.options.iconColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "warningIconColor", false)
      }
    },
    warningIconColorIsThemeColor: {
      get() {
        return this.options.warningIconColorIsThemeColor || this.options.iconColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "warningIconColorIsThemeColor", false)
      }
    },
    warningIconType: {
      get() {
        let warningIconType = this.options.iconType
        if(this.isWarning){
          warningIconType = this.options.warningIconType
        }else{
          this.$changeOptionsEV(this.options.iconSrc, "warningIconSrc", false)
        }
        return warningIconType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "warningIconType", false)
      }
    },
  },
  watch: {
    startVal() {
      if (this.autoplay) {
        this.start()
      }
    },
    endVal() {
      if (this.autoplay) {
        this.start()
      }
      this.updateDynamicData(Number(this.endVal))
    },
    decimals() {
      if (this.autoplay) {
        this.start()
      }
    },
    separator() {
      if (this.autoplay) {
        this.start()
      }
    },
    "options.dynamicData": {
      handler(n, o) {
        this.updateDynamicData(Number(this.endVal))
      },
      deep: true
    }
  },
  mounted() {
    if (this.autoplay) {
      this.start()
    }
    this.$emit("mountedCallback")
    this.updateDynamicData(Number(this.endVal))
  },
  methods: {
    start() {
      this.localStartVal = this.startVal
      this.startTime = null
      this.localDuration = this.duration
      this.paused = false
      this.rAF = requestAnimationFrame(this.count)
    },
    pauseResume() {
      if (this.paused) {
        this.resume()
        this.paused = false
      } else {
        this.pause()
        this.paused = true
      }
    },
    pause() {
      cancelAnimationFrame(this.rAF)
    },
    resume() {
      this.startTime = null
      this.localDuration = +this.remaining
      this.localStartVal = +this.printVal
      requestAnimationFrame(this.count)
    },
    reset() {
      this.startTime = null
      cancelAnimationFrame(this.rAF)
      this.displayValue = this.formatNumber(this.startVal)
      this.digitsArray = this.displayValue.split("")
    },
    count(timestamp) {
      if (!this.startTime) this.startTime = timestamp
      this.timestamp = timestamp
      const progress = timestamp - this.startTime
      this.remaining = this.localDuration - progress

      if (this.useEasing) {
        if (this.countDown) {
          this.printVal =
            this.localStartVal - this.easingFn(progress, 0, this.localStartVal - this.endVal, this.localDuration)
        } else {
          this.printVal = this.easingFn(
            progress,
            this.localStartVal,
            this.endVal - this.localStartVal,
            this.localDuration
          )
        }
      } else {
        if (this.countDown) {
          this.printVal = this.localStartVal - (this.localStartVal - this.endVal) * (progress / this.localDuration)
        } else {
          this.printVal = this.localStartVal + (this.endVal - this.localStartVal) * (progress / this.localDuration)
        }
      }
      if (this.countDown) {
        this.printVal = this.printVal < this.endVal ? this.endVal : this.printVal
      } else {
        this.printVal = this.printVal > this.endVal ? this.endVal : this.printVal
      }

      this.displayValue = this.formatNumber(this.printVal)
      this.digitsArray = this.displayValue.split("")
      if (progress < this.localDuration) {
        this.rAF = requestAnimationFrame(this.count)
      } else {
        this.$emit("callback")
      }
    },
    isNumber(val) {
      return !isNaN(parseFloat(val))
    },
    formatNumber(num) {
      num = num.toFixed(this.decimals)
      num += ""
      const x = num.split(".")
      let x1 = x[0]
      const x2 = x.length > 1 ? this.decimal + x[1] : ""
      const rgx = /(\d+)(\d{3})/
      if (this.separator && !this.isNumber(this.separator)) {
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, "$1" + this.separator + "$2")
        }
      }
      return x1 + x2
    },
    // 警告数据
    updateDynamicData(contentValue) {
      if(!this.onWarningStatus){
        return
      }
      this.getResultObj()
      this.isWarning = false
      // 遍历动态数据条件
      for (let i = 0; i < this.options.dynamicData.length; i++) {
        const dynamicDataItem = this.options.dynamicData[i]
        switch (dynamicDataItem.condition) {
          case "等于":
            if (contentValue === Number(dynamicDataItem.parameter)) {
              this.getResultObj(dynamicDataItem)
              this.isWarning = true
              continue
            }
            break
          case "不等于":
            if (contentValue !== Number(dynamicDataItem.parameter)) {
              this.getResultObj(dynamicDataItem)
              this.isWarning = true
              continue
            }
            break
          case "大于等于":
            if (contentValue >= Number(dynamicDataItem.parameter)) {
              this.getResultObj(dynamicDataItem)
              this.isWarning = true
              continue
            }
            break
          case "小于等于":
            if (contentValue <= Number(dynamicDataItem.parameter)) {
              this.getResultObj(dynamicDataItem)
              this.isWarning = true
              continue
            }
            break
          case "大于":
            if (contentValue > Number(dynamicDataItem.parameter)) {
              this.getResultObj(dynamicDataItem)
              this.isWarning = true
              continue
            }
            break
          case "小于":
            if (contentValue < Number(dynamicDataItem.parameter)) {
              this.getResultObj(dynamicDataItem)
              this.isWarning = true
              continue
            }
            break
          case "介于":
            if (
                contentValue > Number(dynamicDataItem.conditionRange[0]) &&
                contentValue <= Number(dynamicDataItem.conditionRange[1])
            ) {
              this.getResultObj(dynamicDataItem)
              this.isWarning = true
              continue
            }
            break
        }
      }
    },
    getResultObj(dynamicDataItem){
      if(dynamicDataItem){
        this.warningIconSrc = dynamicDataItem.resultIconSrc
        this.warningIconType = dynamicDataItem.resultIconType
        this.warningIconColor = this.$parseColor(dynamicDataItem.resultIconColor)
        this.warningIconColorIsThemeColor = dynamicDataItem.resultIconColorIsThemeColor
      }else{
        this.$changeOptionsEV(this.options.iconSrc, "warningIconSrc", false, null, this.myid, true)
        this.$changeOptionsEV(this.options.iconType, "warningIconType", false, null, this.myid, true)
        this.$changeOptionsEV(this.options.iconColor, "warningIconColor", false, null, this.myid, true)
        this.$changeOptionsEV(this.options.iconColorIsThemeColor, "warningIconColorIsThemeColor", false, null, this.myid, true)
      }
    }
  },
  destroyed() {
    cancelAnimationFrame(this.rAF)
  }
}
</script>
<style>
.d-roll-wrapper {
  width: 100%;
}
.d-roll-list {
  display: inline-block;
  margin: 0 auto;
  padding: 0;
  text-align: center;
  overflow: hidden;
  align-items: flex-end;
}
.number_flex {
  display: flex;
}
.d-roll-list .d-roll-item {
  display: flex;
  list-style: none;
  float: left;
  flex-grow: 1;
  overflow: hidden;
  justify-content: center;
  align-items: center;
}
.d-roll-list-left .icon{
  float: left;
}
.d-roll-list .d-roll-item:last-child {
  margin-right: 0 !important;
}
</style>
